var exports = {
  "P": "xa15a2ab7--8efd82--book-button-container",
};

module.exports = exports;
